import { cloneDeep } from 'lodash';
import { iconColorGetter, TAILLE_ICON_GRAND, TAILLE_ICON_PETIT } from '@/services/general/iconColorGetter';
import { formatDate } from './formatTab';

function triReseaux(data) {
  const dataTempo = data.map((e, i) => {
    return {
      index: i,
      value1: e.depCode ? parseInt(e.depCode, 10) : 0,
      value2: e.ville.toLowerCase(),
    };
  });

  dataTempo.sort((a, b) => {
    if (a.value1 - b.value1 < 0) return -1;
    if (a.value1 - b.value1 > 0) return 1;
    if (a.value2 > b.value2) return 1;
    if (a.value2 < b.value2) return -1;
    return 0;
  });

  const result = dataTempo.map((e) => {
    return data[e.index];
  });
  return result;
}

function triFaces(data) {
  const dataTempo = data.map((e, i) => {
    return {
      index: i,
      value1: parseInt(e.codePostal.slice(0, 2), 10),
      value2: e.ville.toLowerCase(),
    };
  });

  dataTempo.sort((a, b) => {
    if (a.value1 - b.value1 < 0) return -1;
    if (a.value1 - b.value1 > 0) return 1;
    if (a.value2 > b.value2) return 1;
    if (a.value2 < b.value2) return -1;
    return 0;
  });

  const result = dataTempo.map((e) => {
    return data[e.index];
  });
  return result;
}

export default function initialize(opportunite) {
  if (!opportunite || !opportunite.data || !opportunite.data.produits) {
    return;
  }
  if (Array.isArray(opportunite.data.produits.panneauxLc)) {
    opportunite.data.produits.panneauxLc.forEach((el) => {
      el.extensionOpportunite.date = el.date ? formatDate(el.extensionOpportunite.date) : null;
      el.select = false;
      if (el.codeFormat === '4' || el.codeFormat === '3') el.icon = iconColorGetter('#d33115', TAILLE_ICON_GRAND, el.azimut, true);
      else el.icon = iconColorGetter('#d33115', TAILLE_ICON_PETIT, el.azimut, true);
    });
    if (opportunite.data.produits.panneauxLc.length) {
      opportunite.data.produits.panneauxLc = triFaces(opportunite.data.produits.panneauxLc);
    }
  }
  if (Array.isArray(opportunite.data.produits.panneauxNumeriques)) {
    opportunite.data.produits.panneauxNumeriques.forEach((el) => {
      el.select = false;
      if (el.codeFormat === '4' || el.codeFormat === '3') el.icon = iconColorGetter('#009ce0', TAILLE_ICON_GRAND, el.azimut, true);
      else el.icon = iconColorGetter('#009ce0', TAILLE_ICON_PETIT, el.azimut, true);
    });
    if (opportunite.data.produits.panneauxNumeriques.length) {
      opportunite.data.produits.panneauxNumeriques =
        triFaces(opportunite.data.produits.panneauxNumeriques);
    }
  }
  if (Array.isArray(opportunite.data.produits.reseauxLc)) {
    opportunite.data.produits.reseauxLc.forEach((el) => {
      el.extensionOpportunite.date =
        el.extensionOpportunite.date ? formatDate(el.extensionOpportunite.date) : null;
      el.select = false;
    });
    if (opportunite.data.produits.reseauxLc.length) {
      opportunite.data.produits.reseauxLc = triReseaux(opportunite.data.produits.reseauxLc);
    }
  }
  if (Array.isArray(opportunite.data.produits.reseauxNumeriques)) {
    opportunite.data.produits.reseauxNumeriques.forEach((el) => {
      el.select = false;
    });
    if (opportunite.data.produits.reseauxNumeriques.length) {
      opportunite.data.produits.reseauxNumeriques =
        triReseaux(opportunite.data.produits.reseauxNumeriques);
    }
  }
  if (Array.isArray(opportunite.data.produits.reseauxPersonnalise)) {
    opportunite.data.produits.reseauxPersonnalise.forEach((el) => {
      el.dateDebut = el.dateDebut ? formatDate(el.dateDebut) : null;
      el.dateFin = el.dateFin ? formatDate(el.dateFin) : null;
      el.select = false;
    });
  }
  if (Array.isArray(opportunite.data.produits.reseauxTempo)) {
    opportunite.data.produits.reseauxTempo.forEach((el) => {
      el.select = false;
      if (!(el.listeFaces && el.listeFaces.length)) el.listeFaces = [];
      const facesExtension = el.extensionOpportunite.faces;
      if (facesExtension && facesExtension.length) {
        el.listeFaces = cloneDeep(facesExtension);
      }
      el.extensionOpportunite.faces = [];
    });
    opportunite.data.produits.reseauxTempo = triReseaux(opportunite.data.produits.reseauxTempo);
  }
  opportunite.dateValidite = opportunite.dateValidite ? formatDate(opportunite.dateValidite) : null;

  if (opportunite.data.client && opportunite.data.client.nomCommercial) {
    opportunite.annonceur = opportunite.data.client.nomCommercial;
  }

  if (Array.isArray(opportunite.data.produits.reseauxPersonnalise)) {
    opportunite.data.produits.reseauxPersonnalise.forEach((el) => {
      el.faces = [];
      if (Array.isArray(opportunite.data.produits.panneauxLc)) {
        opportunite.data.produits.panneauxLc.forEach((data) => {
          if (data.extensionOpportunite.reseauPersoGuid === el.guid) {
            el.faces.push(data);
          }
        });
      }
      if (Array.isArray(opportunite.data.produits.panneauxNumeriques)) {
        opportunite.data.produits.panneauxNumeriques.forEach((data) => {
          if (data.extensionOpportunite.reseauPersoGuid === el.guid) {
            el.faces.push(data);
          }
        });
      }
      if (Array.isArray(opportunite.data.produits.reseauxLc)) {
        opportunite.data.produits.reseauxLc.forEach((data) => {
          if (data.extensionOpportunite.reseauPersoGuid === el.guid) {
            el.faces.push(...data.listeFaces);
          }
        });
      }
      if (Array.isArray(opportunite.data.produits.reseauxTempo)) {
        opportunite.data.produits.reseauxTempo.forEach((data) => {
          if (data.extensionOpportunite.reseauPersoGuid === el.guid) {
            el.faces.push(...data.listeFaces);
          }
        });
      }
      if (Array.isArray(opportunite.data.produits.reseauxNumeriques)) {
        opportunite.data.produits.reseauxNumeriques.forEach((data) => {
          if (data.extensionOpportunite.reseauPersoGuid === el.guid) {
            el.faces.push(...data.listeFaces);
          }
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/opportunite/opportuniteInitializer.js